


import NoSleep from 'nosleep.js'
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class KeepAwake extends Vue {
  // @ts-ignore
  public noSleep: window.NoSleep

  async mounted() {
    this.initNoSleep()
  }

  public async beforeDestroy() {
    this.disableNoSleep()
  }

  public initNoSleep() {
    this.noSleep = new NoSleep()
    // Enable nosleep when user interacts with the page (enters it's name)
    document.addEventListener('keydown', this.enableNoSleep)
    document.addEventListener('click', this.enableNoSleep)
    document.addEventListener('touchstart', this.enableNoSleep)
  }
  public enableNoSleep() {
    if (this.noSleep) {
      document.removeEventListener('keydown', this.enableNoSleep, false)
      document.removeEventListener('click', this.enableNoSleep, false)
      document.removeEventListener('touchstart', this.enableNoSleep, false)
      this.noSleep.enable()
      console.log('nosleep enabled')
    }
  }

  public disableNoSleep() {
    if (this.noSleep) {
      this.noSleep.disable()
      console.log('nosleep disabled')
    }
  }
}
